<template>
  <FloatingBar v-if="isVisible" :info_icon="hasFailed" data-testid="redaction-banner" @close="isClosed = true">
    <template #message>
      <span v-if="hasFailed" class="message" data-testid="redaction-banner-failed">
        Redaction failed &mdash;
        <a href="#" data-testid="redaction-banner-retry" @click.prevent="retry()">try again</a>.
      </span>
      <span v-else class="message" data-testid="redaction-banner-ready">Redacted video is ready.</span>
    </template>
  </FloatingBar>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { FloatingBar } from '@/storybook/floatingbar';
import { useRedactionStore } from '@/modules/viewer/store/useRedactionStore';
import { useItemActions } from '@/modules/viewer/composables/useItemActions';
import { useUser } from '@/modules/viewer/composables/useUser';

const redactionStore = useRedactionStore();
const { summary } = storeToRefs(redactionStore);
const { isCurrentItemOwner } = useUser();
const { redactAction } = useItemActions();

const isClosed = ref(false);

// A dismissal covers the run that was showing, not the next one to report.
watch(
  () => summary.value?.status,
  () => {
    isClosed.value = false;
  }
);

const hasFailed = computed(() => redactionStore.hasFailed);
const isVisible = computed(() => isCurrentItemOwner.value && !isClosed.value && (redactionStore.isRedacted || hasFailed.value));

const retry = () => {
  redactAction();
};
</script>

<style scoped>
.message {
  @apply text-sm;
}
</style>
